// import React from "react";
import { useSelector } from "react-redux";
import en from "./locale/en.json";
import ph from "./locale/ph.json";
import cn from "./locale/cn.json";
import id from "./locale/id.json";
import th from "./locale/th.json";
import vn from "./locale/vn.json";

export const t2 = (key, language) => {
	let translated = "";
	if (language === "en") {
		if (en[key] !== undefined) translated = en[key];
	} else if (language === "ph") {
		if (ph[key] !== undefined) translated = ph[key];
	} else if (language === "cn") {
		if (cn[key] !== undefined) translated = cn[key];
	} else if (language === "id") {
		if (id[key] !== undefined) translated = id[key];
	} else if (language === "th") {
		if (th[key] !== undefined) translated = th[key];
	} else if (language === "vn") {
		if (vn[key] !== undefined) translated = vn[key];
	}

	// default
	if (translated === "") {
		if (en[key] !== undefined) translated = en[key];
		else translated = key;
	}

	return translated;
};

const Locale = (key) => {
	const language = useSelector((state) => state.Language);

	let translated = "";
	if (language === "en") {
		if (en[key] !== undefined) translated = en[key];
	} else if (language === "ph") {
		if (ph[key] !== undefined) translated = ph[key];
	} else if (language === "cn") {
		if (cn[key] !== undefined) translated = cn[key];
	} else if (language === "id") {
		if (id[key] !== undefined) translated = id[key];
	} else if (language === "th") {
		if (th[key] !== undefined) translated = th[key];
	} else if (language === "vn") {
		if (vn[key] !== undefined) translated = vn[key];
	}

	// default
	if (translated === "") {
		if (en[key] !== undefined) translated = en[key];
		else translated = key;
	}

	return translated;
};

export default Locale;
